import { FolderContent } from '@/api/generatedApi';
import { isAsset } from '@/utils/assets';
import { memo } from 'react';
import { AssetContentCard } from './AssetContentCard';
import { FolderContentCard } from './FolderContentCard';

const ContentCardInner = ({
  content,
  onContextMenu,
  onContentRemoved,
}: {
  content: FolderContent;
  onContextMenu?: (event: React.MouseEvent) => void;
  onContentRemoved?: (id: string) => void;
}) => {
  if (isAsset(content)) {
    return <AssetContentCard asset={content} onContextMenu={onContextMenu} onContentRemoved={onContentRemoved} />;
  }
  return <FolderContentCard folder={content} onContextMenu={onContextMenu} onContentRemoved={onContentRemoved} />;
};

export const ContentCard = memo(ContentCardInner);
